import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

import classes from './CalendarBoxSmall.scss';

import * as flightActions from '../../../store/actions/index';

const calendarBoxSmall = (props) => {

    const queryParams = [];
    queryParams.push("ADT=" + props.requestParams.ADT);
    queryParams.push("CHD=" + props.requestParams.CHD);
    queryParams.push("INF=" + props.requestParams.INF);
    queryParams.push("class=Economy");
    queryParams.push("destination=" + props.requestParams.destination);
    queryParams.push("destinationCountry=" + props.requestParams.destinationCountry);
    queryParams.push("flexi=" + 0);
    queryParams.push("origin=" + props.requestParams.origin);
    queryParams.push("originCountry=" + props.requestParams.originCountry);
    queryParams.push("source=fresco-home");
    queryParams.push("version=" + 1.1);
    queryParams.push("viewName=normal");
    queryParams.push("noOfSegments=" + 1);
    queryParams.push("flight_depart_date=" + moment(props.date, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    queryParams.push("type=O");
    const queryString = queryParams.join("&");

    const monthArray = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dayArray = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const dateFull = new Date(moment(props.date, 'YYYY-MM-DD').format('YYYY-MM-DD'));
    const date = dateFull.getUTCDate();
    const day = dateFull.getUTCDay();
    const month = dateFull.getUTCMonth();

    let dayUpdated;
    let monthUpdated;
    
    for (let i = 0; i <= dayArray.length + 1; i++) {
      if (i === day) {
        dayUpdated = dayArray[i];
      }
    }

    for (let i = 0; i <= monthArray.length + 1; i++) {
      if (i === month) {
        monthUpdated = monthArray[i];
      }
    }

    return (
        <div className={[classes.Box, props.active ? classes.BoxActive : null].join(' ')} onClick={() => {
            props.history.push({
                pathname: "/flights/search",
                search: "?" + queryString
            });
        }}>
            <div>
                <span className={classes.Date}>{dayUpdated},</span>
                <span className={classes.Day}>{date}&nbsp;</span>
                <span className={classes.Day}>{monthUpdated}</span>
            </div>
            <div>
                <span className={[classes.Price, props.lfActive ? classes.PriceLowest : null].join(' ')}>&#8377; {parseInt(props.lf, 10).toLocaleString()}</span>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        requestParams: state.flights.requestParams
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onResetSearch: () => dispatch(flightActions.resetSearch())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(calendarBoxSmall));


// WEBPACK FOOTER //
// ./src/components/CalendarSmall/CalendarBoxSmall/CalendarBoxSmall.js